module.exports = __webpack_public_path__ + "static/vib_play9-2b6591cd2a312b4f27512bfec55f227d.jpg";